import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { visiblePillars, type AutomacaoPillar } from "@/data/automacaoServices";
import { Photo } from "@/components/shared/Photo";
import { cn } from "@/lib/utils";

export interface PillarCardsProps {
  /** Default: `visiblePillars` (respeita `ERP_PILLAR_ENABLED`). */
  pillars?: AutomacaoPillar[];
  className?: string;
}

/**
 * Cards dos pilares de automação (hub /automacao-empresarial). Cada card
 * leva à página do pilar. Preço vem de `pillar.from` (fonte única em
 * `automacaoServices.ts`). Não filtra pilar: quem decide é `visiblePillars`.
 */
export function PillarCards({ pillars = visiblePillars, className }: PillarCardsProps) {
  return (
    <div
      className={cn("grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-[18px]", className)}
    >
      {pillars.map((p) => (
        <Link
          key={p.slug}
          to={`/automacao-empresarial/${p.slug}`}
          className="flex flex-col overflow-hidden rounded-[18px] border border-border bg-card shadow-card transition-[border-color,transform] duration-150 hover:-translate-y-0.5 hover:border-primary"
        >
          {p.photo && (
            <div className="aspect-[16/9] overflow-hidden border-b border-border">
              <Photo id={p.photo} sizes="(max-width: 900px) 100vw, 560px" />
            </div>
          )}
          <div className="flex flex-1 flex-col gap-3.5 p-[26px]">
            <div className="flex items-center justify-between">
              <span className="inline-flex h-7 items-center gap-2 rounded-lg bg-muted pl-1.5 pr-[11px] text-[11px] font-bold text-muted-foreground">
                <span className="inline-flex h-[18px] w-[18px] items-center justify-center rounded-[5px] bg-white">
                  <img src={p.logo} alt="" className="h-[14px] w-[14px] object-contain" />
                </span>
                Sistema-base: {p.systemName}
              </span>
              <ArrowUpRight className="h-[18px] w-[18px] text-primary" aria-hidden />
            </div>
            <h3 className="text-[19px] font-bold leading-[1.3] tracking-[-0.02em]">{p.tag}</h3>
            <p className="text-sm leading-[1.6] text-muted-foreground">{p.promise}</p>
            <div className="mt-auto flex items-center justify-between border-t border-border pt-3.5">
              <span className="text-xs text-muted-foreground">a partir de</span>
              <span className="text-sm font-bold">{p.from}</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default PillarCards;
